// @ts-nocheck
/**
 * بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ
 * Shiffa Hero Immersive — Heaven of Medicine
 * Parallax · Golden particles · 3D word reveal · Mouse depth
 * Performance-first: RAF-batched, passive listeners, GPU compositing
 */
(function () {
  'use strict';

  var hero = document.getElementById('shiffa-hero');
  if (!hero) return;

  // =============================================
  // 1. GOLDEN PARTICLE SYSTEM
  // =============================================
  var canvas = hero.querySelector('.sh-particles-canvas');
  if (canvas) {
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var particles = [];
    var W, H;
    var animId;
    var mouseX = -1, mouseY = -1;

    function resize() {
      W = canvas.clientWidth;
      H = canvas.clientHeight;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function createParticle() {
      var isGold = Math.random() > 0.2;
      return {
        x: Math.random() * W,
        y: Math.random() * H,
        r: Math.random() * 2.2 + 0.4,
        vx: (Math.random() - 0.5) * 0.08,
        vy: -(Math.random() * 0.18 + 0.05),
        opacity: Math.random() * 0.5 + 0.1,
        fadeDir: Math.random() > 0.5 ? 1 : -1,
        isGold: isGold,
        phase: Math.random() * Math.PI * 2,
        drift: Math.random() * 0.3 + 0.1
      };
    }

    function initParticles() {
      particles = [];
      var count = Math.min(70, Math.floor(W * H / 14000));
      for (var i = 0; i < count; i++) {
        particles.push(createParticle());
      }
    }

    function drawParticles() {
      ctx.clearRect(0, 0, W, H);
      var t = performance.now() * 0.001;

      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.vx + Math.sin(t * p.drift + p.phase) * 0.15;
        p.y += p.vy;
        p.opacity += p.fadeDir * 0.0025;
        if (p.opacity > 0.6) p.fadeDir = -1;
        if (p.opacity < 0.05) p.fadeDir = 1;
        if (p.y < -10) { p.y = H + 10; p.x = Math.random() * W; }
        if (p.x < -10) p.x = W + 10;
        if (p.x > W + 10) p.x = -10;

        if (mouseX > 0 && mouseY > 0) {
          var dx = p.x - mouseX;
          var dy = p.y - mouseY;
          var distSq = dx * dx + dy * dy;
          if (distSq < 14400) { // 120^2
            var dist = Math.sqrt(distSq);
            var force = (120 - dist) / 120 * 0.2;
            p.x += (dx / dist) * force;
            p.y += (dy / dist) * force;
          }
        }

        var alpha = Math.max(0, Math.min(1, p.opacity));
        var color = p.isGold
          ? 'rgba(200, 167, 76, ' + alpha.toFixed(3) + ')'
          : 'rgba(46, 125, 50, ' + alpha.toFixed(3) + ')';

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = color;
        ctx.fill();

        if (p.r > 1.4) {
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r * 3.5, 0, Math.PI * 2);
          var glowColor = p.isGold
            ? 'rgba(200, 167, 76, ' + (alpha * 0.12).toFixed(3) + ')'
            : 'rgba(46, 125, 50, ' + (alpha * 0.1).toFixed(3) + ')';
          ctx.fillStyle = glowColor;
          ctx.fill();
        }
      }

      // Connection lines
      ctx.lineWidth = 0.5;
      for (var a = 0; a < particles.length; a++) {
        for (var b = a + 1; b < particles.length; b++) {
          var ddx = particles[a].x - particles[b].x;
          var ddy = particles[a].y - particles[b].y;
          var dd = ddx * ddx + ddy * ddy;
          if (dd < 12000) {
            var lineAlpha = (1 - dd / 12000) * 0.04;
            ctx.strokeStyle = 'rgba(200, 167, 76, ' + lineAlpha.toFixed(4) + ')';
            ctx.beginPath();
            ctx.moveTo(particles[a].x, particles[a].y);
            ctx.lineTo(particles[b].x, particles[b].y);
            ctx.stroke();
          }
        }
      }

      animId = requestAnimationFrame(drawParticles);
    }

    canvas.addEventListener('mousemove', function(e) {
      var rect = canvas.getBoundingClientRect();
      mouseX = e.clientX - rect.left;
      mouseY = e.clientY - rect.top;
    }, { passive: true });
    canvas.addEventListener('mouseleave', function() {
      mouseX = -1;
      mouseY = -1;
    }, { passive: true });

    var particleObserver = new IntersectionObserver(
      function(entries) {
        if (entries[0].isIntersecting) {
          if (!animId) drawParticles();
        } else {
          cancelAnimationFrame(animId);
          animId = null;
        }
      },
      { threshold: 0.05 }
    );

    resize();
    initParticles();
    particleObserver.observe(canvas);

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() { resize(); initParticles(); }, 200);
    }, { passive: true });
  }

  // =============================================
  // 2. SCROLL-REACTIVE PARALLAX — Lerp-Smoothed
  // Uses interpolation for buttery-smooth movement
  // =============================================
  var layers = hero.querySelectorAll('[data-parallax-speed]');
  var contentInner = hero.querySelector('.sh-content__inner');
  var gradientOverlay = hero.querySelector('.sh-gradient-overlay');

  // Lerp targets for each layer + content
  var scrollCurrent = 0;
  var scrollTarget = 0;
  var contentOpacity = 1;
  var contentOpacityTarget = 1;
  var contentY = 0;
  var contentYTarget = 0;
  var contentScale = 1;
  var contentScaleTarget = 1;
  var gradientOp = 1;
  var gradientOpTarget = 1;
  var parallaxRunning = window.innerWidth > 768;
  var SCROLL_LERP = 0.08;
  var CONTENT_LERP = 0.06;

  function updateScrollTargets() {
    scrollTarget = window.pageYOffset || document.documentElement.scrollTop;
    var heroH = hero.offsetHeight;
    var progress = Math.min(1, scrollTarget / (heroH * 0.6));

    contentOpacityTarget = Math.max(0.2, 1 - progress * 0.7);
    contentYTarget = progress * 20;
    contentScaleTarget = 1 - progress * 0.03;
    gradientOpTarget = 1 + Math.min(1, scrollTarget / (heroH * 0.5)) * 0.3;
  }

  function animateParallax() {
    if (!parallaxRunning) return;

    // Smooth interpolation
    scrollCurrent += (scrollTarget - scrollCurrent) * SCROLL_LERP;
    contentOpacity += (contentOpacityTarget - contentOpacity) * CONTENT_LERP;
    contentY += (contentYTarget - contentY) * CONTENT_LERP;
    contentScale += (contentScaleTarget - contentScale) * CONTENT_LERP;
    gradientOp += (gradientOpTarget - gradientOp) * CONTENT_LERP;

    var heroH = hero.offsetHeight;
    if (scrollTarget <= heroH * 1.5) {
      for (var i = 0; i < layers.length; i++) {
        var speed = parseFloat(layers[i].dataset.parallaxSpeed) || 0.1;
        var yOffset = scrollCurrent * speed;
        layers[i].style.transform = 'translate3d(0, ' + yOffset.toFixed(1) + 'px, 0)';
      }
    }

    if (contentInner && scrollTarget < heroH) {
      contentInner.style.opacity = contentOpacity.toFixed(3);
      contentInner.style.transform = 'translateY(' + contentY.toFixed(1) + 'px) scale(' + contentScale.toFixed(4) + ')';
    }

    if (gradientOverlay) {
      gradientOverlay.style.opacity = gradientOp.toFixed(3);
    }

    requestAnimationFrame(animateParallax);
  }

  if (window.innerWidth > 768) {
    window.addEventListener('scroll', updateScrollTargets, { passive: true });
    updateScrollTargets();
    requestAnimationFrame(animateParallax);
  }

  // =============================================
  // 3. ENTRANCE ANIMATIONS — Fast & Crisp
  // =============================================
  function animateEntrance() {
    var heading = hero.querySelector('.sh-heading');
    if (heading) {
      var allWords = heading.querySelectorAll('.sh-word__inner');
      allWords.forEach(function(w, i) { w.style.setProperty('--word-index', i); });

      var reveal = function() { heading.classList.add('is-visible'); };
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function() { setTimeout(reveal, 30); });
      } else {
        setTimeout(reveal, 80);
      }
    }

    var animElements = hero.querySelectorAll('[data-animate]');
    animElements.forEach(function(el) {
      var delay = Math.max(0, (parseInt(el.dataset.delay) || 0) * 0.5);
      setTimeout(function() { el.classList.add('is-visible'); }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', animateEntrance);
  } else {
    requestAnimationFrame(function() { requestAnimationFrame(animateEntrance); });
  }

  // =============================================
  // 4. MOUSE-REACTIVE DEPTH (Desktop)
  // Lerp-smoothed for silky cursor tracking
  // =============================================
  if (window.matchMedia('(pointer: fine)').matches) {
    var mandalaLayer = hero.querySelector('.sh-layer--mandala');
    var geoLayer = hero.querySelector('.sh-layer--geometry');
    var mX = 0, mY = 0;
    var cX = 0, cY = 0;
    var cardTiltX = 0, cardTiltY = 0;
    var MOUSE_LERP = 0.065;
    var TILT_LERP = 0.05;

    hero.addEventListener('mousemove', function(e) {
      var rect = hero.getBoundingClientRect();
      mX = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
      mY = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
    }, { passive: true });

    function animateMouse() {
      cX += (mX - cX) * MOUSE_LERP;
      cY += (mY - cY) * MOUSE_LERP;

      if (mandalaLayer) {
        var scrollOfs = scrollCurrent * 0.15;
        mandalaLayer.style.transform = 'translate3d(' + (cX * 18).toFixed(1) + 'px, ' + ((cY * 12) + scrollOfs).toFixed(1) + 'px, 0)';
      }
      if (geoLayer) {
        var scrollOfsGeo = scrollCurrent * 0.25;
        geoLayer.style.transform = 'translate3d(' + (cX * -12).toFixed(1) + 'px, ' + ((cY * -10) + scrollOfsGeo).toFixed(1) + 'px, 0)';
      }

      // Subtle tilt on glass card — lerp-smoothed
      if (contentInner) {
        var scrollY = window.pageYOffset || 0;
        if (scrollY < hero.offsetHeight * 0.3) {
          var targetTiltX = cY * -1.5;
          var targetTiltY = cX * 1.5;
          cardTiltX += (targetTiltX - cardTiltX) * TILT_LERP;
          cardTiltY += (targetTiltY - cardTiltY) * TILT_LERP;
          contentInner.style.transform = 'perspective(1200px) rotateX(' + cardTiltX.toFixed(2) + 'deg) rotateY(' + cardTiltY.toFixed(2) + 'deg)';
        }
      }

      requestAnimationFrame(animateMouse);
    }

    requestAnimationFrame(animateMouse);
  }

  // =============================================
  // 5. PERFORMANCE: Pause when not visible
  // =============================================
  var heroObserver = new IntersectionObserver(
    function(entries) {
      if (entries[0].isIntersecting) {
        hero.classList.remove('is-hidden');
        if (!parallaxRunning && window.innerWidth > 768) {
          parallaxRunning = true;
          updateScrollTargets();
          requestAnimationFrame(animateParallax);
        }
      } else {
        hero.classList.add('is-hidden');
        parallaxRunning = false;
      }
    },
    { threshold: 0.01 }
  );
  heroObserver.observe(hero);

})();
